module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('i', {
    staticClass: "ball_01"
  }), _vm._v(" "), _c('i', {
    staticClass: "ball_02"
  }), _vm._v(" "), _c('i', {
    staticClass: "ball_03",
    staticStyle: {
      "background": "#f9f906"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ball_04"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loadingBox"
  }), _vm._v(" "), _c('i', {
    staticClass: "loading loading-del"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13910bae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ybb_loading.vue
// module id = 1325
// module chunks = 0